export class FooterInfo {
    public elementName?: string;
    public pageSize?: number;
    public allowedPageSizes? = [{designation: '10', value: 10}, {designation: '20', value: 20}, {designation: '50', value: 50},
    {designation: '100', value: 100}];
    public actualPage?: number;
    public totalPages?: number;
    public totalElements?: number;
}